<template>
	<div>
		<nuxt />
	</div>
</template>

<script>
import brazeHelper from '~/assets/util/braze'

export default {
	computed: {
		isAuthenticated () {
			return this.$store.getters['auth/isAuthenticated']
		},
		authUserId () {
			return this.$store.state.auth.user && this.$store.state.auth.user.uid
		}
	},
	watch: {
		isAuthenticated: {
			immediate: true,
			handler (authenticated) {
				if (!authenticated || !this.authUserId) { return }

				brazeHelper.identifyBrazeUser(this.$brazeClient, this.authUserId, {}, this.$log)

				if (
					typeof Notification !== 'undefined' &&
					Notification.permission === 'default' &&
					brazeHelper.isBrazePushSupported(this.$brazeClient)
				) {
					setTimeout(() => {
						if (typeof navigator !== 'undefined' && 'serviceWorker' in navigator) {
							navigator.serviceWorker.ready
								.then(() => brazeHelper.requestBrazePushPermission(this.$brazeClient))
								.catch(() => {})
						}
					}, 1500)
				}
			}
		}
	}
}
</script>
